import { DSFormFieldDescription } from 'shared-definitions/types'

export function makeHiddenInput(name: string, value: string): DSFormFieldDescription {
  return {
    type: 'hidden',
    value,
    name,
    placeholder: '',
    required: true,
  }
}
